import * as React from 'react';
import classNames from 'classnames';
import './styles/WarningBanner.scss';

interface Props {
  type: 'info' | 'warning' | 'error' | 'success';
  label?: React.ReactNode;
  title?: string;
  showCloseBtn?: boolean;
  link?: React.ReactNode;
}

const WarningBanner: React.FC<Props> = ({ label, showCloseBtn, type, link, title }) => {
  const [isVisible, setIsVisible] = React.useState(true);

  if (!isVisible) {
    return null;
  }

  const getIconClass = () => {
    switch (type) {
      case 'info':
      case 'error':
        return 'error';
      case 'warning':
        return 'report';
      case 'success':
        return 'check_circle';
    }
  };

  return (
    <div
      role="alert"
      className={classNames('lp-warning-banner', {
        'lp-warning-banner-info': type === 'info',
        'lp-warning-banner-warning': type === 'warning',
        'lp-warning-banner-error': type === 'error',
      })}>
      <i className="lp-warning-banner-icon material-symbols"> {getIconClass()}</i>
      <div className="lp-warning-banner-inner">
        {title && <div className="lp-warning-banner-title">{title}</div>}
        {label}
        {link && <div className="lp-warning-banner-link">{link}</div>}
      </div>

      {showCloseBtn && (
        <i className="lp-warning-banner-close material-symbols" onClick={() => setIsVisible(false)}>
          close
        </i>
      )}
    </div>
  );
};

export default WarningBanner;
